import axios from 'axios'
import { getToken, HEADER_PREFIX } from 'utils/auth'
import { getSentryHeaders } from 'utils/sentry'

const axiosConfig = {
  baseURL: `${process.env.REACT_APP_API_URL}/v1`,
  timeout: 15000,
  headers: {
    'content-type': 'application/json',
  },
}

const axiosServerV1 = axios.create(axiosConfig)

axiosServerV1.interceptors.request.use(async (config) => {
  const userToken = await getToken()
  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: userToken ? `${HEADER_PREFIX} ${userToken}` : 'None',
      ...getSentryHeaders(),
    },
  }
})

// TODO: move to auth context
axiosServerV1.interceptors.response.use(
  (response) =>
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    response,
  (error) =>
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    Promise.reject(error)
)

export default axiosServerV1
